let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("efgkt")).then(() => parcelRequire('fEzvG'));